import { render } from "./ProjectTasks.vue?vue&type=template&id=291a344c"
import script from "./ProjectTasks.vue?vue&type=script&lang=js"
export * from "./ProjectTasks.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__